<template>
  <div class="relative">
    <button
      type="button"
      class="flex items-center gap-2 rounded-lg px-3 py-2 text-gray-700 transition-colors hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
      @click="isOpen = !isOpen"
    >
      <div class="flex h-8 w-8 items-center justify-center rounded-full bg-indigo-100 dark:bg-indigo-900/40">
        <UserCircleIcon class="h-5 w-5 text-indigo-700 dark:text-indigo-300" />
      </div>
      <ChevronDownIcon class="h-4 w-4" />
    </button>

    <Transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div
        v-if="isOpen"
        class="absolute right-0 z-50 mt-2 w-56 origin-top-right rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800"
        @click.stop
      >
        <div class="border-b border-gray-200 px-4 py-3 dark:border-gray-700">
          <p class="text-sm font-semibold text-gray-900 dark:text-gray-100">
            {{ authStore.account?.displayName || authStore.account?.loginName }}
          </p>
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
            {{ authStore.account?.loginName }}
          </p>
        </div>

        <div class="py-1">
          <button
            type="button"
            class="flex w-full items-center px-4 py-2 text-sm text-gray-700 transition-colors hover:bg-indigo-50 dark:text-gray-300 dark:hover:bg-indigo-900/50"
            @click="handleLogout"
          >
            <ArrowLeftOnRectangleIcon class="mr-3 h-4 w-4" />
            退出登录
          </button>
        </div>
      </div>
    </Transition>

    <div v-if="isOpen" class="fixed inset-0 z-40" @click="isOpen = false"></div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { ArrowLeftOnRectangleIcon, ChevronDownIcon, UserCircleIcon } from "@heroicons/vue/24/outline";

import { logoutAPI } from "@/api/auth";
import { useToken } from "@/hooks/useToken";
import { useAuthStore } from "@/stores/auth";

const router = useRouter();
const authStore = useAuthStore();
const { removeToken } = useToken();
const isOpen = ref(false);

/**
 * 退出当前租户控制台登录状态。
 */
const handleLogout = async () => {
  isOpen.value = false;
  try {
    await logoutAPI();
  } finally {
    removeToken();
    authStore.clearAuthContext();
    router.push("/login");
  }
};
</script>
